module.exports = __webpack_public_path__ + "static/img/long-img.d78e7dd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/promotion-h5/long-img.jpg
// module id = PosI
// module chunks = 2